<a class="small-card-button" tabindex="tab" [attr.data-testid]="testId()" [ngClass]="{ disabled: isDisabled }">
  <div class="button-text">{{ name }}</div>
  <mat-icon class="card-arrow" [svgIcon]="IconNames.ice_chevron_right" />
</a>
